import cn from 'classnames';
import { InputProps } from './input.props';
import styles from './input.module.scss';

export const Input = ({ className, ...rest }: InputProps): JSX.Element => {
  const moduleStyles = cn(styles.module, className);

  return <input className={moduleStyles} {...rest} />;
};
